export default class WapiLimitSettings {
  constructor() {
    this.max_preset_area = 0;
    this.max_area_request = 0;
    this.max_point_request_count = 0;
    this.max_preset_request_count = 0;
    this.is_strict_restriction = false;
  }
}
